import React from "react";
import styled from "@emotion/styled";
import { HomeLayout } from "components/HomeLayout/HomeLayout";
import { Faq } from "./features/Faq";
import { FeatureLanding } from "./features/FeatureLanding";
import { Cta } from "./features/Cta";
import { FeatureSupport } from "./features/FeatureSupport";
import { FeatureClaimAchievements } from "./features/FeatureClaimAchievements";
import { FeatureCommunity } from "./features/FeatureCommunity";
import { FeatureApi } from "./features/FeatureApi";
import { FeatureSecurity } from "./features/FeatureSecurity";
import { FeaturePrices } from "./features/FeaturePrices";
import { FeatureProtection } from "./features/FeatureProtection";
import { FeatureTradeShowcase } from "./features/FeatureTradeShowcase";
import { TABLET_WIDTH } from "hooks/useDeviceType";
import { FeatureCards } from "./features/FeatureCards";
import { FeatureCardsTwo } from "./features/FeatureCardsTwo";

/**
 * Home Page component. Houses the Layout and the sections.
 */
const Home: React.FC = () => {
  return (
    <Container>
      <HomeLayout>
        {/* Features */}
        <ContainerLanding>
          <FeatureLanding />
          <FeatureTradeShowcase />
        </ContainerLanding>
        <FeaturePrices />
        <FeatureCards />
        <FeatureProtection />
        <FeatureSecurity />
        <FeatureApi />
        <FeatureCardsTwo />
        <FeatureCommunity />
        <FeatureClaimAchievements />
        <FeatureSupport />

        <Faq />
        <Cta />
      </HomeLayout>
    </Container>
  );
};

export default Home;

// Sub-components

const Container = styled.div`
  background-color: ${props => props.theme.theme["200"]};
  width: 100%;
  overflow-x: clip;
`;

const ContainerLanding = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 140px;

  @media (max-width: ${TABLET_WIDTH}px) {
    gap: 80px;
  }
`;
